var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAuthenticate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.779,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f0bbb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3139",
    "data-name": "Rectangle 3139",
    width: 80,
    height: 80,
    transform: "translate(16292 1488)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_authenticate",
    transform: "translate(-16292 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_283",
    "data-name": "Union 283",
    d: "M3.151,60A3.136,3.136,0,0,1,0,56.887V27.751a3.135,3.135,0,0,1,3.151-3.116h2.6V20.85a21.082,21.082,0,0,1,42.161,0v3.785h2.6a3.132,3.132,0,0,1,3.147,3.116V56.887A3.133,3.133,0,0,1,50.513,60Zm20.529-20.83v6.3a3.151,3.151,0,0,0,6.3,0v-6.3a3.151,3.151,0,0,0-6.3,0ZM41.615,24.635V20.85a14.785,14.785,0,0,0-29.569,0v3.785Z",
    transform: "translate(16305.17 1498)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuthenticate);
export default __webpack_public_path__ + "static/media/ic_authenticate.fee6dca864f88d4a46526aefae11945c.svg";
export { ForwardRef as ReactComponent };